import { useState } from 'react'
import CollapseImage from './CollapseImage'
import { CollapseImageGroupInterface } from '../../../Interfaces/CollapseInterface'

type CurrentCollapseType = {
  index: number
  show: boolean
}
const CollapseImageGroup = ({
  items,
  removeElementAfterChange,
  className,
}: CollapseImageGroupInterface) => {
  const [currentCollapse, setCurrentCollapse] = useState<CurrentCollapseType>({
    index: 0,
    show: true,
  })

  return (
    <>
      <div
        className={`${
          className ?? ''
        } flex justify-center items-center flex-col gap-[1px]`}
      >
        {items?.map(
          (n, i) =>
            n.isShow && (
              <CollapseImage
                className={n.className}
                title={n.title}
                url={n.url}
                key={i}
                index={currentCollapse.index === i && currentCollapse.show}
                keyItem={i}
                isShow={n.isShow}
                onClick={(index) =>
                  setCurrentCollapse({
                    ...currentCollapse,
                    index: index,
                    show:
                      currentCollapse.index === index
                        ? !currentCollapse.show
                        : true,
                  })
                }
                element={n.element}
              />
            )
        )}
      </div>
    </>
  )
}

export default CollapseImageGroup
